/**
 *
 * initial-list (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-01-23
 *
 */

(function () {

	const list = document.querySelector('.content-member-wrap');
	if (null == list) {
		return;
	}

	const origin     = list.querySelectorAll('.item-member');
	const chars = [...'ABCDEFGHIJKLNMOPQRSTUVWXYZ'];
	const posts      = {};
	let current	     = null;
	
	// const buttons    = document.createElement('ul');
	// buttons.classList.add('list-item-initial');

	chars.forEach(function (char) {

		posts[char] = list.querySelectorAll('[data-initial="' + char + '"]');

		const button = document.createElement('li');
		const anker = document.createElement('a');
	
		button.classList.add('item-initial');
		
		// const btn = document.querySelectorAll('.initials-list button');
		anker.textContent = char;
		anker.dataset.hasPost = posts[char].length;
		const url = location.href.replace(location.hash, "");
		//const url = 'http://localhost:3001/member';
		//anker.location.hash = char.toLowerCase();
		//anker.href = location.href;
		anker.setAttribute('href', url + '#' + char.toLowerCase());
		// buttons.append(button);
		button.append(anker);
		const heading = document.createElement('h3');
		const wrap = document.createElement('ul');
		wrap.classList.add('list-item-member-initial');
		heading.id = char.toLowerCase();
		heading.dataset.hasPost = posts[char].length;
		heading.classList.add('member');
		wrap.dataset.hasPost = posts[char].length;
		// const dt = document.createElement('dt');
		//
		// heading.classList.add('active');
		// wrap.classList.add('active');
		heading.textContent = char;
		if (posts[char].length !== 0) {
			list.append(heading);
			list.append(wrap);
			
			posts[char].forEach(function (post) {
				wrap.appendChild(post);
			})
		}

		anker.addEventListener('click', function (e) {
			// if(button.classList)
			//list.textContent = '';

				// e.target.classList.add('selected');
				anker.setAttribute('href', url + '#' + char.toLowerCase());
				// if (null != current) {
				// 	current.classList.remove('selected');
				// 	// anker.setAttribute('href', url + '#' + char.toLowerCase());
				// }
				//current = e.target;
				// posts[char].forEach(function (post) {
				// 	list.appendChild(post);
				// }{

		});

		
	});

	//list.insertAdjacentElement('beforebegin', buttons);
})();
